<script lang="ts">
	import checkmark from "@core/assets/icons/checkmark-emoji.svg";
	import Media from "./common/Media.svelte";

	const { class: customClass }: { class?: string } = $props();
</script>

<Media
	source={{ src: checkmark, type: "image/svg+xml" }}
	class={[customClass, "size-[1em]"]}
	width={88}
	height={88}
	alt="✅"
/>
